import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	yAxisLabel: {
		id: 'software-deployment-frequency-report.issues-per-deployment-chart.chart.y-axis-label',
		defaultMessage: 'Median issues',
		description: 'Y axis label indicating y axis value is showing median number of issues',
	},
	xAxisLabel: {
		id: 'software-deployment-frequency-report.issues-per-deployment-chart.chart.x-axis-label',
		defaultMessage: 'Week commencing',
		description:
			'X axis label indicating x axis value is a date that represents the starting date of the week',
	},
});
